OT.createNS('OT.Search.GeoLocation');

var COOKIES_EXPIRATION_TIME = 1000 * 60 * 60 * 24; // 24 hours.

OT.Search.ApplyUserGeoLocation = function() {
    'use strict';

    var shouldCheckLocation = OT.Search.Data.get().Display.CheckUserGeoLocation;

    if (shouldCheckLocation && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function(results) {
            if (results && results.coords) {
                var previousUserLat = OT.Common.Cookies.get('search_user_lat');
                var previousUserLon = OT.Common.Cookies.get('search_user_lon');

                OT.Common.Cookies.set({
                    search_user_lat: results.coords.latitude,
                    search_user_lon: results.coords.longitude
                }, COOKIES_EXPIRATION_TIME);

                // We are checking for 'undefined' strings, because OT.Common.Cookies returns a stringified undefined.
                if (previousUserLat === 'undefined' || previousUserLon === 'undefined') {
                    // If cookies has expired or haven't been set before, do a search refresh.
                    // We are not checking for differences in lat/lon, because it might be very minor
                    // and we only care about a ~city level range. Because of that, we have a small cookie life time.
                    OT.Search.Params.set({
                        Latitude: results.coords.latitude,
                        Longitude: results.coords.longitude
                    });
    
                    OT.Search.Requests.Results.get();
                }
            }
        });
    }    
};
